exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".childrenContainer-2fRvj{opacity:1;-webkit-transition:height .3s ease-out,opacity .2s .1s ease-out;transition:height .3s ease-out,opacity .2s .1s ease-out;z-index:500}.childrenContainer-2fRvj.transition-3aRku{overflow:hidden}.childrenContainer-2fRvj.collapsed-2KIVx{opacity:0;overflow:hidden;-webkit-transition-timing-function:ease-in,ease-in;transition-timing-function:ease-in,ease-in}.childrenContainer-2fRvj>div{padding:.05px}", ""]);

// exports
exports.locals = {
	"childrenContainer": "childrenContainer-2fRvj",
	"transition": "transition-3aRku",
	"collapsed": "collapsed-2KIVx"
};